<template>
  <input type="text" ref="inputField" />
</template>

<script lang="ts">
import fieldFormatter from "@/func/format/fieldFormatter";
import { sfFieldFormatter } from "@/types/generalTypes";
import { SfMathAnswerField } from "@/types/mathsTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {},
  props: {
    modelValue: { type: String, required: true },
    answerData: { type: Object as PropType<SfMathAnswerField>, required: true },
  },
  data() {
    return {
      inputFormatter: null as sfFieldFormatter | null,
      lastUpdate: '',
    };
  },
  mounted() {
    const field = this.$refs.inputField as HTMLInputElement;
    this.inputFormatter = fieldFormatter(
      field, 
      this.answerData.fullFormat, 
      this.onUpdate
    );
  },
  beforeUnmount() {
    if(this.inputFormatter) {
      this.inputFormatter.destroy();
    }
  },
  methods: {
    onUpdate(val: string) {
      this.lastUpdate = val;
      this.$emit('update:modelValue', val); 
    }
  },
  watch: {
    modelValue(n: string, o: string) {
      if(this.lastUpdate === n) {
        return;
      }
      if(n == o) {
        return;
      }
      if(this.inputFormatter) {
        this.inputFormatter.update(n);
      }
    },
  },
});
</script>
